import React, { useEffect, useRef, useState } from 'react';

import CommonImage from '@components/CommonImage';

const DEFAULT_USER_PIC = `/images/pro_pic_default.svg`;

const TeamMember = ({ memberData, onAddMember, onRemoveMember, onChange, parentComponent }) => {
	const [selectedTab, setSelectedTab] = useState('LIST');
	let fashionDesigner = memberData.usersByTypeList?.FASHION_DESIGNER;
	let projectManager = memberData.usersByTypeList?.PROJECT_MANAGER;
	let merchandiser = memberData.usersByTypeList?.MERCHANDISER;
	let sampleDevelopment = memberData.usersByTypeList?.SAMPLE_DEVELOPMENT;
	let productDevelopment = memberData.usersByTypeList?.PRODUCT_DEVELOPMENT;
	let costingManager = memberData.usersByTypeList?.COSTING_MANAGER;
	let qa = memberData.usersByTypeList?.QA;
	let searchUserText = memberData.searchUserText;
	let searchUserSuggestions = memberData.searchUserSuggestions;
	let memberList = memberData.memberList;
	const userInfo = JSON.parse(localStorage.getItem('userInfo'));
	const resultsRef = useRef();
	const inputRef = useRef();

	useEffect(() => {
		if (selectedTab === 'ADD') {
			inputRef.current.focus();
		}
	}, [selectedTab]);

	const onSetInputFocus = (type) => {
		setSelectedTab(type);
	};

	useEffect(() => {
		if (memberList) {
			document.body.addEventListener('keydown', onKeyDown);
		} else {
			document.body.removeEventListener('keydown', onKeyDown);
		}
		return () => {
			document.body.removeEventListener('keydown', onKeyDown);
		};
	}, [memberList]);

	function onKeyDown(event) {
		const isUp = event.key === 'ArrowUp';
		const isDown = event.key === 'ArrowDown';
		const inputIsFocused = document.activeElement === inputRef.current;

		const resultsItems = Array.from(resultsRef?.current?.children || []);
		const activeResultIndex = resultsItems.findIndex((child) => {
			return child === document.activeElement;
		});

		if (isUp) {
			if (inputIsFocused) {
				resultsItems[resultsItems.length - 1] && resultsItems[resultsItems.length - 1].focus();
			} else if (resultsItems[activeResultIndex - 1]) {
				resultsItems[activeResultIndex - 1].focus();
			} else {
				inputRef.current && inputRef.current.focus();
			}
		}

		if (isDown) {
			if (inputIsFocused) {
				resultsItems[0] && resultsItems[0].focus();
			} else if (resultsItems[activeResultIndex + 1]) {
				resultsItems[activeResultIndex + 1].focus();
			} else {
				inputRef.current && inputRef.current.focus();
			}
		}
	}

	const renderUserInfo = (member, type) => {
		return (
			<div>
				{' '}
				{member.map((item, index) => (
					<div
						className="single-person d-flex justify-content-between align-items-center"
						key={`${item.id}-${index}`}
					>
						<div className="person-info d-flex align-items-center">
							<div className="image">
								<CommonImage
									src={item?.profilePicDocUrl || item?.profilePicDocument?.docUrl}
									alt="person"
									fallbackSrc={DEFAULT_USER_PIC}
									isStatic={
										item?.profilePicDocUrl || item?.profilePicDocument?.docUrl
											? false
											: true
									}
								/>
							</div>
							<div className="details-info">
								<div className="name">
									<p>
										{item.name}
										{item.designation ? (
											<span className="designation">
												{item.primaryUserType === 'BUYER'
													? 'Buyer'
													: item.designation}
											</span>
										) : (
											''
										)}
									</p>
									<p className="email">{item.email}</p>
								</div>
							</div>
						</div>

						{parentComponent === 'PROJECT_MANAGEMENT_TOOLS' ? (
							// For PROJECT_MANAGEMENT_TOOLS
							type === 'remove' && !(userInfo.id === item.id) ? (
								<div className="action text-right">
									{item?.isRemovable ? (
										<span onClick={() => onRemoveMember(item)}>Remove</span>
									) : (
										<CommonImage src="/icons/link.svg" />
									)}
								</div>
							) : !(userInfo.id === item.id) ? (
								<div className="action text-right">
									<span onClick={() => onAddMember(item)}>Add</span>
								</div>
							) : (
								''
							)
						) : // For non-PROJECT_MANAGEMENT_TOOLS
						type === 'remove' && !(userInfo.id === item.id) ? (
							<div className="action text-right">
								<span onClick={() => onRemoveMember(item)}>Remove</span>
							</div>
						) : !(userInfo.id === item.id) ? (
							<div className="action text-right">
								<span onClick={() => onAddMember(item)}>Add</span>
							</div>
						) : (
							''
						)}
					</div>
				))}
			</div>
		);
	};
	const renderUserSuggetion = () => {
		let result = [];
		if (searchUserText) {
			result.push(
				<ul className="p-0 m-0 existing-item" ref={resultsRef}>
					{searchUserSuggestions.length ? (
						searchUserSuggestions.map((item) => {
							return (
								<div
									className="single-person d-flex justify-content-between align-items-center"
									key={item.id}
									tabIndex={0}
									onKeyPress={(e) => {
										if (e.key === 'Enter') {
											onAddMember(item);
										}
									}}
								>
									<div className="person-info d-flex align-items-center">
										<div className="image">
											<CommonImage
												src={
													item?.profilePicDocUrl || item?.profilePicDocument?.docUrl
												}
												fallbackSrc={DEFAULT_USER_PIC}
												alt="person"
												isStatic={
													item?.profilePicDocUrl || item?.profilePicDocument?.docUrl
														? false
														: true
												}
											/>
										</div>
										<div className="details-info">
											<div className="name">
												<p>
													{item.name}
													{item.designation ? (
														<span className="designation">
															{item.primaryUserType === 'BUYER'
																? 'Buyer'
																: item.designation}
														</span>
													) : (
														''
													)}
												</p>
												<p className="email">{item.email}</p>
											</div>
										</div>
									</div>
									{!(userInfo.id === item.id) && (
										<div className="action text-right">
											<span onClick={() => onAddMember(item)}>Add</span>
										</div>
									)}
								</div>
							);
						})
					) : (
						<li>
							<div className="d-flex align-items-center">
								<div className="d-flex flex-column ml-2">
									<span>No suggestions found</span>
								</div>
							</div>
						</li>
					)}
				</ul>
			);
		}
		return result;
	};

	return (
		<div className="team-section">
			<div className="top-section">
				<div className="container-fluid">
					<div className="row first-row">
						<div className="col-12 d-flex justify-content-between no-padding">
							<div className="team-heading">
								<h3>Team</h3>
							</div>
						</div>
					</div>
					<nav>
						<div className="nav" id="nav-tab">
							<span
								className={`nav-link cursor-pointer ${
									selectedTab === 'LIST' ? 'active' : ''
								}`}
								id="nav-home-tab"
								onClick={() => onSetInputFocus('LIST')}
							>
								Member list
							</span>
							<span
								className={`nav-link cursor-pointer ${selectedTab === 'ADD' ? 'active' : ''}`}
								id="nav-profile-tab"
								onClick={() => onSetInputFocus('ADD')}
							>
								Add member
							</span>
						</div>
					</nav>
					<div className="tab-content" id="nav-tabContent">
						{selectedTab === 'LIST' ? (
							<div className="show active">
								<div className="all-team-members-without-search">
									<div className="manager-designation-persons">
										{memberList && memberList.length !== 0 ? (
											renderUserInfo(memberList, 'remove')
										) : (
											<span className="no-member">No member added yet</span>
										)}
									</div>
								</div>
							</div>
						) : (
							<div>
								<div className="member-search">
									<div className="search flex-grow-1">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="16.55"
											height="16.508"
											viewBox="0 0 16.55 16.508"
										>
											<path
												id="Path_23797"
												data-name="Path 23797"
												d="M15.916,15.191l-3.89-3.89a6.831,6.831,0,1,0-.674.674l3.89,3.89a.482.482,0,0,0,.337.142.468.468,0,0,0,.337-.142A.48.48,0,0,0,15.916,15.191ZM1,6.826A5.867,5.867,0,1,1,6.872,12.7,5.874,5.874,0,0,1,1,6.826Z"
												transform="translate(0.2 0.25)"
												fill="#a1a6b2"
												stroke="#a1a6b2"
												strokeWidth="0.5"
											/>
										</svg>
										<input
											type="search"
											autoComplete="off"
											placeholder="Search member"
											className="w-100"
											name="searchUserText"
											value={searchUserText}
											onChange={onChange}
											ref={inputRef}
										/>
									</div>
								</div>
								<div className="all-team-members">
									{!searchUserText ? (
										<>
											{projectManager && (
												<div className="manager-designation-persons">
													<div className="designation-title">
														<h4>Project Manager</h4>
													</div>
													{projectManager && projectManager.length !== 0
														? renderUserInfo(projectManager, 'add')
														: 'No project manager added yet'}
												</div>
											)}
											{fashionDesigner && (
												<div className="manager-designation-persons">
													<div className="designation-title">
														<h4>Fashion Designer</h4>
													</div>
													{fashionDesigner && fashionDesigner.length !== 0
														? renderUserInfo(fashionDesigner, 'add')
														: 'No fashion designer added yet'}
												</div>
											)}
											{qa && (
												<div className="manager-designation-persons">
													<div className="designation-title">
														<h4>Qa</h4>
													</div>
													{qa && qa.length !== 0
														? renderUserInfo(qa, 'add')
														: 'No qa added yet'}
												</div>
											)}
											{merchandiser && (
												<div className="manager-designation-persons">
													<div className="designation-title">
														<h4>Merchandiser</h4>
													</div>
													{merchandiser && merchandiser.length !== 0
														? renderUserInfo(merchandiser, 'add')
														: 'No merchandiser added yet'}
												</div>
											)}
											{sampleDevelopment && (
												<div className="manager-designation-persons">
													<div className="designation-title">
														<h4>Sample development</h4>
													</div>
													{sampleDevelopment && sampleDevelopment.length !== 0
														? renderUserInfo(sampleDevelopment, 'add')
														: 'No sample man added yet'}
												</div>
											)}
											{productDevelopment && (
												<div className="manager-designation-persons">
													<div className="designation-title">
														<h4>Product development</h4>
													</div>
													{productDevelopment && productDevelopment.length !== 0
														? renderUserInfo(productDevelopment, 'add')
														: 'No product man added yet'}
												</div>
											)}
											{costingManager && (
												<div className="manager-designation-persons">
													<div className="designation-title">
														<h4>Costing Manager</h4>
													</div>
													{costingManager && costingManager.length !== 0
														? renderUserInfo(costingManager, 'add')
														: 'No costing manager added yet'}
												</div>
											)}
										</>
									) : (
										renderUserSuggetion()
									)}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default TeamMember;
